<template>
  <section class="company-profile">
    <div class="container profile-container">
      <div class="profile-text-content">
        <h2 class="main-title">{{ $t('companyProfile.titleZh') }}</h2>
        <p class="sub-title">{{ $t('companyProfile.titleEn') }}</p>
        <p class="profile-paragraph">{{ $t('companyProfile.p1') }}</p>
        <p class="profile-paragraph">{{ $t('companyProfile.p2') }}</p>
        <p class="profile-paragraph">{{ $t('companyProfile.p3') }}</p>
      </div>
      <div class="profile-image-wrapper">
        <img :src="profileImage" :alt="$t('companyProfile.imageAlt')" class="profile-image" />
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: 'CompanyProfile',
  data() {
    return {
      // Use a placeholder or an actual image URL.
      // For local images: profileImage: require('@/assets/your-profile-image.jpg')
    profileImage: require('@/assets/gztp.jpg')
    };
  },
};
</script>

<style scoped>
.company-profile {
  padding: 60px 0;
  background-color: #ffffff; /* Or a light gray like #f8f9fa */
}

.container.profile-container { /* More specific selector */
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 20px;
  display: flex;
  align-items: flex-start; /* Align items to the top */
  gap: 50px; /* Space between text and image */
}

.profile-text-content {
  flex: 1.5; /* Give more space to text */
  line-height: 1.7; /* From image, text seems to have good line spacing */
}

.main-title {
  font-size: 2.4em; /* Adjust as per image */
  color: #2c3e50;
  margin-bottom: 0px; /* Closer to subtitle */
  font-weight: 600;
}

.sub-title {
  font-size: 1.6em; /* Adjust as per image */
  color: #34495e;
  font-weight: bold;
  margin-top: 5px;
  margin-bottom: 30px;
}

.profile-paragraph {
  font-size: 1em; /* Adjust to match image (looks like 15-16px) */
  color: #555;
  margin-bottom: 20px;
  text-align: justify; /* Or left */
}

.profile-image-wrapper {
  flex: 1;
  display: flex;
  justify-content: center; /* Center image if container is wider */
  align-items: flex-start;
}

.profile-image {
  max-width: 100%;
  height: auto;
  border-radius: 8px;
  box-shadow: 0 5px 20px rgba(0, 0, 0, 0.1);
}

/* Responsive Adjustments */
@media (max-width: 992px) {
  .container.profile-container {
    flex-direction: column;
    align-items: center; /* Center items when stacked */
  }
  .profile-text-content {
    order: 2; /* Text below image on small screens if desired, or 1 for text above */
    margin-bottom: 30px; /* Space when stacked */
    text-align: left; /* Keep text left aligned */
  }
  .main-title, .sub-title {
    text-align: center;
  }
  .profile-image-wrapper {
    order: 1; /* Image above text */
    width: 80%;
    margin-bottom: 30px;
  }
}

@media (max-width: 768px) {
  .main-title {
    font-size: 2em;
  }
  .sub-title {
    font-size: 1.4em;
  }
  .profile-paragraph {
    font-size: 0.95em;
  }
  .profile-image-wrapper {
    width: 90%;
  }
}
</style>